import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { YMaps, Map, Placemark } from '@pbe/react-yandex-maps'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next";
import s from './MapPage.module.css';
import { domain } from '../../store/authSlice';


export const MapPage = () => {
  const [points, setPoints] = useState([]);
  const [filteredPoints, setFilteredPoints] = useState([]);
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    startTime: "",
    endTime: "",
    probabilityRange: "",
    probabilityField: "mean_confidence"
  });
  const [showFilters, setShowFilters] = useState(false);
  const navigate = useNavigate();
  const { audioId } = useParams();
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const lang = i18n.language; // "en" | "ru" | "be"

  // Загружаем данные
useEffect(() => {
  const loadPoints = () => {
    if (audioId) {
      axios.get(domain + `api/coordinates/?id=${audioId}`)
        .then(res => setPoints([res.data]))  
        .catch(err => console.error('Ошибка при загрузке точки:', err));
    } else {
      axios.get(domain + 'api/all-with-coordinates/')
        .then(res => {
          const filtered = res.data.filter(p => !p.deleted && p.validated);
          setPoints(filtered);
          })
        .catch(err => console.error('Ошибка при загрузке точек:', err));
    }
  };

  loadPoints(); 
  window.addEventListener("pointsUpdated", loadPoints);
  return () => window.removeEventListener("pointsUpdated", loadPoints);
}, [audioId]);

  
  useEffect(() => {
    
    if (
      !filters.startDate &&
      !filters.endDate &&
      !filters.startTime &&
      !filters.endTime &&
      !filters.probabilityRange
    ) {
      setFilteredPoints(points);
      return;
    }

    const filtered = points.filter((point) => {
      const date = new Date(point.date_of_collection);

      // фильтр по дате
      if (filters.startDate) {
        const start = new Date(filters.startDate);
        start.setHours(0, 0, 0, 0);
        if (date < start) return false;
      }
      if (filters.endDate) {
        const end = new Date(filters.endDate);
        end.setHours(23, 59, 59, 999);
        if (date > end) return false;
      }

      // фильтр по времени
      const timeStr = date.toTimeString().slice(0, 5); // HH:MM
      if (filters.startTime && timeStr < filters.startTime) return false;
      if (filters.endTime && timeStr > filters.endTime) return false;

      // фильтр по вероятности
      if (filters.probabilityRange) {
        const [min, max] = filters.probabilityRange.split("-").map(Number);

        const match = point.recognized_birds_species.some((bird) => {
          const value = bird[filters.probabilityField];
          if (value === null || value === undefined) return false;
          const percent = value * 100; // API возвращает 0–1
          return percent >= min && percent <= max;
        });

        if (!match) return false;
      }

      return true;
    });

    setFilteredPoints(filtered);
  }, [points, filters]);

  // Сброс фильтров
  const resetFilters = () => {
    setFilters({
      startDate: "",
      endDate: "",
      startTime: "",
      endTime: "",
      probabilityRange: "",
      probabilityField: "mean_confidence"
    });
    setFilteredPoints(points); 
    setShowFilters(false); 
  };

  return (
    <div style={{ position: 'relative', height: '90vh', width: '100%' }}>
      {/* кнопка назад */}
      <button className={s.backButton} onClick={() => navigate(-1)}>
        {t('back_to_collection')}
      </button>

      {/* кнопка фильтров */}
      <button
        className={s.filterToggle}
        onClick={() => setShowFilters(!showFilters)}
      >
        {showFilters ? t('closeFilters') : t('filters')}
      </button>

      {/* панель фильтров */}
      {showFilters && (
        <div className={s.filterPanel}>
          <label>
            {t('start_date')}
            <input
              type="date"
              value={filters.startDate}
              onChange={(e) => setFilters((f) => ({ ...f, startDate: e.target.value }))}
            />
          </label>
          <label>
            {t('end_date')}
            <input
              type="date"
              value={filters.endDate}
              onChange={(e) => setFilters((f) => ({ ...f, endDate: e.target.value }))}
            />
          </label>
          <label>
            {t('start_time')}
            <input
              type="time"
              value={filters.startTime}
              onChange={(e) => setFilters((f) => ({ ...f, startTime: e.target.value }))}
            />
          </label>
          <label>
            {t('end_time')}
            <input
              type="time"
              value={filters.endTime}
              onChange={(e) => setFilters((f) => ({ ...f, endTime: e.target.value }))}
            />
          </label>
          <label>
            {t('prob_field')}
            <select
              value={filters.probabilityField}
              onChange={(e) => setFilters((f) => ({ ...f, probabilityField: e.target.value }))}
            >
              <option value="mean_confidence">{t('mean_confidence')}</option>
              <option value="max_confidence">{t('max_confidence')}</option>
            </select>
          </label>
          <label>
            {t('prob_range')}
            <select
              value={filters.probabilityRange}
              onChange={(e) => setFilters((f) => ({ ...f, probabilityRange: e.target.value }))}
            >
              <option value="">{t('all')}</option>
              <option value="91-100">91–100%</option>
              <option value="81-90">81–90%</option>
              <option value="71-80">71–80%</option>
              <option value="61-70">61–70%</option>
              <option value="51-60">51–60%</option>
              <option value="0-50">0–50%</option>
            </select>
          </label>

          {/* кнопка сброса */}
          <button className={s.resetButton} onClick={resetFilters}>
            {t('reset_filters')}
          </button>
        </div>
      )}

      {/* карта */}
      <YMaps query={{ apikey: 'ce4ea19b-77cf-4121-b9ba-e88501f65833' }}>
        <Map defaultState={{ center: [53.9, 27.5667], zoom: 6 }} width="100%" height="100%">
          {filteredPoints.map((point) => (
            <Placemark
              key={point.id}
              geometry={[point.lat, point.lng]}
              properties={{
                balloonContent: `
                  <div style="max-width: 300px; overflow: auto;">
                    <strong>${t('file_name')}</strong> ${point.name}<br/>
                    <strong>${t('date')}</strong> ${new Date(point.date_of_collection).toLocaleString()}<br/>
                    <strong>${t('birds')}</strong><br/>
                    <table border="1" cellpadding="4" cellspacing="0" style="border-collapse: collapse; width: 100%; margin-top: 5px;">
                      <thead>
                        <tr>
                          <th>${lang.toUpperCase()}</th>
                          <th>${t('prob_table')}</th>
                        </tr>
                      </thead>
                      <tbody>
                        ${
                          point.recognized_birds_species
                            .filter(bird => bird.verbose)
                            .map(bird => {
                              const probability = bird[filters.probabilityField]
                                ? (bird[filters.probabilityField] * 100).toFixed(0) + "%" 
                                : "-";

                              const birdName = (() => {
                                
                                let name =
                                  lang === "EN" ? bird.en :
                                  lang === "RU" ? bird.ru :
                                  lang === "BE" ? bird.be :
                                  bird.lat;

                                
                                if (!name && bird.verbose) {
                                  try {
                                    const namesArray = JSON.parse(bird.verbose.replace(/'/g, '"')); 
                                    if (lang === "EN") name = namesArray[0];
                                    if (lang === "RU") name = namesArray[1];
                                    if (lang === "BE") name = namesArray[2];
                                  } catch (err) {
                                    console.error("Ошибка парсинга verbose:", bird.verbose, err);
                                    name = "-";
                                  }
                                }

                                return name || "-";
                              })();

                              return `
                                <tr>
                                  <td>${birdName || "-"}</td>
                                  <td>${probability}</td>
                                </tr>`;
                            })
                            .join("")
                        }
                      </tbody>
                    </table>
                  </div>
                `
              }}
              options={{
                preset: 'islands#icon',
                iconColor: '#1E90FF',
                balloonMaxWidth: 400,  
                balloonAutoPan: true
              }}
              modules={['geoObject.addon.balloon']}
            />
          ))}
        </Map>
      </YMaps>
    </div>
  )
}